import $api from "../http";
import { AxiosResponse } from "axios";

export default class EventsService {

    static getEvents(page: number): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/events/?page=${page}`)
    };

    static getEvent(id: number): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/events/${id}`)
    };

    static updateEvent(id: number, data: any): Promise<AxiosResponse<any>> {
        return $api.patch<any>(`api/events/update/${id}`, data)
    };

    static getSpecEvents(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/events/spec/')
    };

    static createEvent(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/events/spec/', data)
    };

    static removeEvent(id: number): Promise<AxiosResponse> {
        return $api.delete(`api/events/delete/${id}`)
    };

};